import PropTypes from "prop-types";
import { StyledButton } from "../../styles/Button";

export default function Button({
	children,
	icon,
	disabled = false,
	onClick,
	alabel,
	small = false,
	bg = true,
	type = "button",
	testid,
	initial,
}) {
	return (
		<StyledButton
			disabled={disabled}
			onClick={onClick}
			aria-label={alabel}
			small={small}
			bg={bg}
			type={type}
			data-testid={testid}
			initial={initial}
		>
			{icon ? <img src={icon} alt={icon} role="img" /> : undefined}
			<span>{children}</span>
		</StyledButton>
	);
}

Button.propTypes = {
	children: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
	disabled: PropTypes.bool,
	onClick: PropTypes.func,
	icon: PropTypes.any,
	alabel: PropTypes.string,
	small: PropTypes.bool,
	bg: PropTypes.bool,
	type: PropTypes.string,
	testid: PropTypes.string,
	initial: PropTypes.bool,
};
